export const events = {
  createCostCenterStart: 'Add Cost Center Start',
  createCostCenterSubmit: 'Add Cost Center Submit',
  createCostCenterCancel: 'Add Cost Center Cancel',
  renameCostCenterStart: 'Rename Cost Center Start',
  renameCostCenterSubmit: 'Rename Cost Center Submit',
  renameCostCenterCancel: 'Rename Cost Center Cancel',
  deleteCostCenterStart: 'Delete Cost Center Start',
  deleteCostCenterSubmit: 'Delete Cost Center Submit',
  deleteCostCenterCancel: 'Delete Cost Center Cancel',
  goToCostCenterSettings: 'Go to Cost Center Settings',
  goToCostCenterDetail: 'Go to Cost Center Details',
  goToCostCenterManageEmployees: 'Manage Cost Center Clicked',
  newCostcenterAssignmentStarted: 'New Cost Center Assignment Started',
  saveCostCenterAssignment: 'Save Cost Center Assignment',
  deleteCostCenterAssignment: 'Delete Cost Center Assignment',
  addNewCostCenterToAssignment: 'Add New Cost Center to Assignment',
  goToViewEmployes: 'Go to Cost Center View Employees',
  goToViewCostCenterDetails: 'Go to View Cost Center Details',
  bulkAssignmentStart: 'Bulk Assignment Start',
  bulkAssignmentSubmit: 'Bulk Assignment Submit',
  bulkAssigmentTemplateDownload: 'Bulk Assignment Template Download',
  assignCostCenterStart: 'Assign Cost Center Start',
  selectCostCenter: 'Select Cost Center',
  removeCostCenter: 'Remove Cost Center',
  assignCostCenterSuccess: 'Assign Cost Center Success',
  editCostCenterAssignStart: 'Edit Cost Center Assign Start',
  createPayrollEntryStart: 'Create Payroll Entry Start',
  selectPayrollPeriod: 'Select Payroll Period',
  importFileSubmit: 'Import File Submit',
  selectDataSubmit: 'Select Data Submit',
  goBackToImportFile: 'Go back to Import file',
  dataReviewSubmit: 'Data review Submit',
  goBackToSelectData: 'Go back to Select data',
  generateEntrySubmit: 'Generate entry Submit',
  goBackToDataReview: 'Go back to Data review',
  publishEntrySubmit: 'Publish entry Submit',
  goBackToEntryBuilder: 'Go back to Entry Builder',
  exportEntriesStart: 'Export Entries Start',
  exportSubmit: 'Export Submit',
  saveDraft: 'Save Draft',
  viewFinancialWorkspace: 'View Financial Workspace',
  financeWorkspaceGoToMonth: 'Change reporting month',
  financeWorkspaceGoToAccuracy: 'Go to accuracy',
  financeWorkspaceCloseAccuracy: 'Close accuracy',
  financeWorkspaceGoUploadSummary: 'Got to upload summary',
  financeWorkspaceSelectView: 'Select view',
  financeWorkspaceSelectLE: 'Select LE',
  financeWorkspaceSelectManager: 'Select Manager',
  financeWorkspaceSelectDistribution: 'Change cost distribution',
  financeWorkspaceColumnOrder: 'Column order',
  financeWorkspaceGroupTable: 'Select Group',
  financeWorkspaceFilterTable: 'Select Filter',
  financeWorkspaceGoToOrgChart: 'Go to the Org Chart',
  financeWorkspaceGoToFinanceSettings: 'Go to FW Settings',
  financeWorkspaceExportStart: 'FW export start',
  financeWorkspaceExportSubmit: 'FW export submit',
  setAccountLength: 'Set account length',
  setAccountRelationship: 'Set account relationship',
  saveAccountRelationship: 'Save account relationship',
  addVendorStart: 'Add Vendor Start',
  addVendorCancel: 'Add Vendor Cancel',
  addVendorSubmit: 'Add Vendor Submit',
  addVendorAccountSubmit: 'Add Vendor Account Submit',
  editVendorSubmit: 'Edit Vendor Submit',
  addTaxStart: 'Add Tax Start',
  addTaxSubmit: 'Add Tax Submit',
  viewTax: 'View Tax',
  deleteTaxStart: 'Delete Tax Start',
  deleteTaxSubmit: 'Delete Tax Submit',
  renameTaxStart: 'Rename Tax Start',
  renameTaxSubmit: 'Rename Tax Submit',
  addValueStart: 'Add Value Start',
  addValueSubmit: 'Add Value Submit',
  editValueStart: 'Edit Value Start',
  editValueSubmit: 'Edit Value Submit',
  deleteValue: 'Delete Value Start',
  dimensionsDeleteCancel: 'Delete Dimension Cancel',
  dimensionsDeleteSubmit: 'Delete Dimension Submit',
  dimensionsDeleteStart: 'Delete Dimension Start',
  dimensionsRenameSubmit: 'Rename Dimension Submit',
  dimensionsRenameCancel: 'Rename Dimension Cancel',
  dimensionsRenameStart: 'Rename Dimension Start',
  dimensionsAddValueSubmit: 'Add Dimension Value Submit',
  dimensionsAddValueCancel: 'Add Dimension Value Cancel',
  dimensionsAddValueStart: 'Add Dimension Value Start',
  dimensionsSelectLE: 'Select LE',
  dimensionsGoToDimension: 'Go to dimension',
  dimensionsAddSubmit: 'Add dimension submit',
  dimensionsAddStart: 'Add dimension start',
  dimensionsSelectDistribution: 'Select Distribution',
  onboarding: 'Onboarding',
  onboardingHint: 'Onboarding Hint',
  viewBudgetsListPage: 'View Budgets List Page',
  viewBudgetsLanding: 'View Budgets Landing',
  clickAddBudget: 'Click Add Budget',
  completeAddBudget: 'Complete Add Budget',
  goToBudgetDetails: 'Go to Budget Details',
  goToBudgets: 'Go to Budgets',
  openBudgetSidepanel: 'Open Budget Sidepanel',
  addEmployeesToBudget: 'Add Employees to Budget',
  budgetsLandingCtaClicked: 'Budgets Landing CTA Clicked',
  openClientsWizard: 'Open Clients Wizard',
  createClient: 'Create Client',
  viewClientDetailsPage: 'View Client Details Page',
  editClient: 'Edit Client',
  editClientProjects: 'Edit Client Projects',
  openNewContactModal: 'Open New Contact Modal',
  createContact: 'Create Contact',
  viewClientsListPage: 'View Clients List Page',
  viewVendorsListPage: 'View Vendors List Page',
  viewContactDetailsPage: 'View Contact Details Page',
  viewContactsExporterPage: 'View Contacts Exporter Page',
  editContact: 'Edit Contact',
  financialWorkspace: {
    reportRun: 'FW: Report Run',
    userInitiatedReportRun: 'FW: User Initiated Report Run',
  },
  overview: {
    sectionView: 'Go to overview',
    clickJtbd: 'Open overview job to be done',
    dateNavigationFilterChanged: 'Filter overview time',
    pendingActionWidgetView: 'View overview pending widget',
  },
  payments: {
    sectionBulkPayments: 'Go to bulk payments',
    clickCreateBulkPayment: 'Create bulk payment',
    clickContinueBulkPayment: 'Create bulk payment submit',
    selectPayments: 'Select bulk payments',
    addToBulkPayment: 'Add to bulk payment',
    selectOutstandingPayments: 'Select outstanding payments',
    clickSavePayInBulk: 'Create pay in bulk submit',
  },
  banking: {
    addBankAccount: 'Create bank account',
    importTransactionsBankAccount: 'Import transactions submit',
    clickGoToReconcileView: 'Go to reconciliation',
    clickAcceptReconciliationSuggestion: 'Accept reconciliation suggestion',
    clickRejectReconciliationSuggestion: 'Reject reconciliation suggestion',
    clickReconcile: 'Create reconciliation',
    clickNoDocumentReconciliation: 'Create no document reconciliation',
    addPeopleBankAccount: 'Add people bank account',
    deleteBankAccount: 'Delete bank account',
  },
  invoices: {
    uploadInvoice: 'Create invoices start',
    saveUploadInvoice: 'Create invoices submit',
    validate: 'Validate invoice',
    validateAndMarkAsPaid: 'Validate and mark as paid invoice',
    listSendToPay: 'Send to pay invoices submit',
    saveBasicInformation: 'Edit invoice submit',
  },
  saleInvoices: {
    viewSaleInvoicesPage: 'View sale invoices page',
    startCreate: 'Create sale invoice start',
    submitEdit: 'Edit sale invoice submit',
    delete: 'Delete sale invoice',
    downloadPdf: 'Download sale invoice pdf',
    duplicate: 'Duplicate sale invoice',
    cancel: 'Cancel issued sale invoice',
    markAsPaid: 'Mark as paid sale invoice',
    clickCancelInvoice: 'Click on cancel invoice',
    clickCancelIssueInvoice: 'Click on cancel issue invoice',
    clickConfirmInvoice: 'Click on confirm invoice',
    clickDeleteDraftInvoice: 'Click on delete draft invoice',
    clickDownloadPDF: 'Click on Download PDF',
    clickEditDraft: 'Click on Edit draft',
    clickExport: 'Click on export',
    clickIssueInvoice: 'Click on issue invoice',
    clickSaveInvoice: 'Click on save invoice',
    clickDuplicateInvoice: 'Click on duplicate invoice',
  },
  quotes: {
    viewQuotesPage: 'View quotes page',
    startCreate: 'Create quote start',
    submitCreate: 'Create quote submit',
    submitEdit: 'Edit quote submit',
    delete: 'Delete quote',
    downloadPdf: 'Download quote pdf',
    conversionIntoInvoice: 'Convert quote into invoice',
  },
  deals: {
    viewDealsPage: 'View deals page',
    viewClientDealsPage: 'View deals page for client',
    startCreate: 'Create deal start',
    submitCreate: 'Create deal submit',
    startEdit: 'Edit deal start',
    submitEdit: 'Edit deal submit',
    changeStage: 'Change deal stage via swimlane',
    delete: 'Delete deal',
    viewDealDetails: 'View deal details',
    viewDealInvoices: 'View deal invoices',
    viewDealQuotes: 'View deal quotes',
  },
  settings: {
    categories: {
      editCategory: 'Edit category',
      enableCategory: 'Enable category',
      disableCategory: 'Disable category',
      addSubcategory: 'Add subcategory submit',
      editSubcategory: 'Edit subcategory submit',
      enableSubcategory: 'Enable subcategory',
      disableSubcategory: 'Disable subcategory',
      deleteSubcategory: 'Delete subcategory submit',
    },
    bankAccounts: {
      editLedgerAccount: 'Edit ledger account bank account',
    },
    vendors: {
      editLedgerAccount: 'Edit ledger account vendor',
    },
    payrollConcepts: {
      editLedgerAccount: 'Edit ledger account payroll concept',
    },
    defaultConfiguration: {
      save: 'Edit default configuration',
    },
  },
  accounting: {
    sectionChartOfAccounts: 'Go to chart of accounts',
    addNewAccounts: 'Open new accounts',
    bulkImportAccounts: 'New accounts bulk import',
    clickSaveAddImportAccount: 'Create accounts submit',
    clickExportGeneralLedger: 'Export general ledger',
    saveDraftEntry: 'Save draft entry',
    publishDraftEntry: 'Publish draft entry',
  },
  clients: {
    clickImportClients: 'Import clients start',
    uploadImportDocument: 'Import clients upload document',
    startImport: 'Import clients submit',
    confirmImport: 'Confirm import clients',
  },
  vendors: {
    clickImportVendors: 'Import vendors start',
    uploadImportDocument: 'Import vendors upload document',
    startImport: 'Import vendors submit',
    confirmImport: 'Confirm import vendors',
  },
  contacts: {
    clickImportContacts: 'Import contacts start',
    downloadTemplate: 'Download import contacts template',
    uploadImportDocument: 'Import contacts upload document',
    startImport: 'Import contacts submit',
    confirmImport: 'Confirm import contacts',
  },
  contactDocuments: {
    clickOnCancelDeleteFile: 'Click on cancel delete file',
    clickOnConfirmDeleteFile: 'Click on confirm delete file',
    clickOnDeleteFile: 'Click on delete file',
    clickOnDownloadFile: 'Click on download file',
    clickOnUploadConfirmation: 'Click on upload confirmation',
    clickOnUploadFile: 'Click on upload file',
    visitContactDocumentsFilesTab: 'Visit contact documents tab',
  },
  newFinancialWorkspace: {
    activationCenter: {
      opened: 'FW Activation Center opened',
    },
    workforceHistory: {
      opened: 'FW Workforce History opened',
      sectionOpened: 'FW Workforce History section opened',
      fteDataViewed: 'FW Workforce History FTE data viewed',
    },
    visitPayroll: 'Visit FW Payroll data',
    grossSalaryMissingData: {
      modalOpened: 'FW Gross Salary Missing Data modal opened',
      modalClosed: 'FW Gross Salary Missing Data modal closed',
      export: 'FW Gross Salary Missing Data data export',
    },
    launch: {
      landingViewed: 'FW landing no payroll view',
      buttons: {
        requestInformation: 'FW Payroll Request Information',
      },
    },
    payrollUpload: 'FW Payroll Upload Summary Button clicked',
    export: 'FW Export Data',
    bannerViewed: 'FW banner payroll view',
    bannerClosed: 'FW Launch Banner Closed',
    bannerLinkClicked: 'FW Launch Banner Link Clicked',
    compensation: {
      navigateToCompensations: 'Navigated to Compensation page from FW to upload results',
    },
  },
  widgets: {
    clickTitleLink: 'Go to widget view',
  },
}
